import { db } from "../../shared/config";
import {
  collection,
  addDoc,
  getDocs,
  getDoc,
  doc,
  updateDoc,
  deleteDoc,
  query,
  orderBy,
  startAfter,
  endBefore,
  limitToLast,
  limit,
  Timestamp,
  where,
} from "firebase/firestore";
import {
  GET_SCRIBEREQUESTS,
  ADD_SCRIBEREQUEST,
  GET_SCRIBEREQUEST,
  RESET_SCRIBEREQUEST,
  SCRIBEREQUESTS_ERROR,
} from "../types/scriberequest_type";

import { setAlert } from "./alert";
import { LIMIT } from "../../domain/constant";
//GET SCRIBEREQUESTS
const scriberequestsRef = collection(db, "scriberequests");
export const getScriberequests =
  ({ term, termField, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(scriberequestsRef, where(termField, "==", term));
      } else {
        searchQuery = query(
          scriberequestsRef,
          orderBy(orderValue, orderType),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_SCRIBEREQUESTS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: SCRIBEREQUESTS_ERROR,
      });
    }
  };

export const getNextScriberequests =
  ({ term, termField, last, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          scriberequestsRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          scriberequestsRef,
          orderBy(orderValue, orderType),
          startAfter(last[orderValue]),
          limit(LIMIT)
        );
      }
      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_SCRIBEREQUESTS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: SCRIBEREQUESTS_ERROR,
      });
    }
  };
export const getPreviousScriberequests =
  ({ term, termField, first, orderValue = "createdAt", orderType = "desc" }) =>
  async (dispatch) => {
    try {
      let searchQuery = null;
      if (term) {
        searchQuery = query(
          scriberequestsRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT),
          where(termField, "==", term)
        );
      } else {
        searchQuery = query(
          scriberequestsRef,
          orderBy(orderValue, orderType),
          endBefore(first[orderValue]),
          limitToLast(LIMIT)
        );
      }

      const querySnapshot = await getDocs(searchQuery);
      const data = [];
      querySnapshot.forEach((doc) => {
        data.push({ id: doc.id, ...doc.data() });
      });
      dispatch({
        type: GET_SCRIBEREQUESTS,
        payload: data,
      });
    } catch (err) {
      console.log(err);
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: SCRIBEREQUESTS_ERROR,
      });
    }
  };

export const addScriberequest = (data) => async (dispatch) => {
  try {
    data.createdAt = Timestamp.fromDate(new Date());
    const docRef = await addDoc(scriberequestsRef, data);
    dispatch({
      type: ADD_SCRIBEREQUEST,
    });
    dispatch(setAlert("Scriberequest added successfully", "success"));
  } catch (e) {
    console.error("Error adding document: ", e);
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: SCRIBEREQUESTS_ERROR,
    });
  }
};

export const getScriberequest = (id) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_SCRIBEREQUEST,
    });
    const docRef = doc(db, "scriberequests", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      data.id = id;
      dispatch({
        type: GET_SCRIBEREQUEST,
        payload: data,
      });
    } else {
      dispatch(setAlert("Something went wrong", "danger"));
      dispatch({
        type: SCRIBEREQUESTS_ERROR,
      });
    }
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: SCRIBEREQUESTS_ERROR,
    });
  }
};
export const editScriberequest = (id, data) => async (dispatch) => {
  try {
    const docSnap = await updateDoc(doc(db, "scriberequests", id), data);
    dispatch(setAlert("Scriberequest updated successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: SCRIBEREQUESTS_ERROR,
    });
  }
};

export const deleteScriberequest = (id) => async (dispatch) => {
  try {
    const docSnap = await deleteDoc(doc(db, "scriberequests", id));
    dispatch(setAlert("Scriberequest deleted successfully", "success"));
  } catch (err) {
    dispatch(setAlert("Something went wrong", "danger"));
    dispatch({
      type: SCRIBEREQUESTS_ERROR,
    });
  }
};
